import { createSlice } from "@reduxjs/toolkit";
import { deleteDonorMember, getDonorMember } from "./DonorMember.api";

const donorMemberSlice = createSlice({
  name: "donorMember",
  initialState: {
    donorMember: {
      data: [],
      meta: {},
    },
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.surname.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET Banner FILTER WISE DATA
    builder.addCase(getDonorMember.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getDonorMember.fulfilled, (state, action) => {
      state.loading = false;
      state.donorMember = {
        data: action.payload.data, // Ensure this matches your API response
        meta: action.payload.meta,
      };
      state.dataLimit = action.payload.meta?.limit || 10;
      state.currentPage = action.payload.meta?.page || 1;
      state.totalPages = action.payload.meta?.totalPages || 0;
      state.totalData = action.payload.meta?.total || 0;
    });
    builder.addCase(getDonorMember.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteDonorMember.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteDonorMember.fulfilled, (state, action) => {
      const deletedId = action?.payload?.data?._id;
      if (state.donorMember.data && Array.isArray(state.donorMember.data)) {
        state.donorMember.data = state.donorMember.data.filter(
          (donorMember) => donorMember._id !== deletedId
        );
        // Update total count if needed
        state.totalData = state.totalData - 1;
      }
      state.loading = false;
    });
    builder.addCase(deleteDonorMember.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = donorMemberSlice.actions;
export default donorMemberSlice.reducer;
